import { Routes, Route, useNavigate } from "react-router-dom";
import Pages from "./pages";
import UserDetails from "./pages/users/details";
import UsersForm from "./pages/users/form/usersForm";
import { useAppDispatch } from "./hooks/store";
import { useEffect } from "react";
import { STORAGE_KEYS, getFromStorage } from "./constants";
import { resetAuth, setCredentials } from "./reducers/authSlice";

const Routing = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    const token = getFromStorage(STORAGE_KEYS.token);
    if (token && window.location.pathname === "/") {
      dispatch(
        setCredentials({
          token: token,
          user: null,
        })
      );
      navigate("/dashboard", { replace: true });
    } else if (!token && window?.location?.pathname === "/") {
      dispatch(resetAuth());
      navigate("/", { replace: true });
    } else if (token) {
      dispatch(
        setCredentials({
          token: token,
          user: null,
        })
      );
      navigate(window?.location?.pathname);
    } else {
      dispatch(resetAuth());
      navigate("/", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Routes>
      <Route path="/" element={<Pages.LoginPage />} />
      <Route path="forgotpassword" element={<Pages.ForgotPasswordPage />} />
      <Route path="verifyotp" element={<Pages.VerifyOtp />} />
      <Route path="resetpassword" element={<Pages.ResetPassword />} />
      <Route path="changepassword" element={<Pages.ChangePassword />} />
      <Route path="/dashboard" element={<Pages.DashBoardPage />} />
      <Route path="/profile" element={<Pages.Profile />} />
      <Route path="/manageusers" element={<Pages.ManageUsers />} />
      <Route path="/manageusers/userdetails/:id" element={<UserDetails />} />
      <Route path="/manageusers/usersform/:id" element={<UsersForm />} />
      <Route path="/analytics" element={<Pages.Analytics />} />
      <Route path="/faq" element={<Pages.Faq />} />
      <Route path="/cms" element={<Pages.ManageCms />} />
      <Route path="/manage-requests" element={<Pages.ManageRequests />} />
      <Route
        path="/manage-requests/requestdetails/:id"
        element={<Pages.RequestDetails />}
      />
      <Route path="/manage-report" element={<Pages.ManageReport />} />
      <Route
        path="/manage-report/reportdetails/:id"
        element={<Pages.ReportDetail />}
      />
      <Route path="/manage-properties" element={<Pages.ManageProperties />} />
      <Route
        path="/manage-properties/set-profit/:id"
        element={<Pages.SetProfit />}
      />
      <Route
        path="/manage-properties/edit/:id"
        element={<Pages.EditProperties />}
      />
      <Route
        path="/manage-properties/details/:id"
        element={<Pages.PropertyDetails />}
      />
      <Route path="/manage-subAdmin" element={<Pages.ManageSubAdmin />} />
      <Route path="/manage-subAdmin/add" element={<Pages.AddSubAdmin />} />
      <Route path="/manage-subAdmin/edit/:id" element={<Pages.AddSubAdmin />} />

      <Route path="/manage-earnings" element={<Pages.ManageEarnings />} />
      <Route
        path="/manage-transactions"
        element={<Pages.ManageTransactions />}
      />
      <Route
        path="/manage-transactions/details"
        element={<Pages.TransactionDetails />}
      />
      <Route path="/change-requests" element={<Pages.ManageChangeRequests />} />
      <Route path="/customer-support" element={<Pages.CustomerSupport />} />
      <Route
        path="/customer-support/details/:id"
        element={<Pages.QueryDetails />}
      />

      <Route
        path="/manage-form-template"
        element={<Pages.ManageFormTemplate />}
      />
      <Route path="/manage-blogs" element={<Pages.ManageBlogs />} />
      <Route path="/manage-blogs/details/:id" element={<Pages.BlogDetails />} />
      <Route path="/manage-blogs/add-blog" element={<Pages.AddBlog />} />
      <Route path="/manage-blogs/edit/:id" element={<Pages.AddBlog />} />
      <Route path="/manage-news" element={<Pages.ManageNews />} />
      <Route path="/manage-news/details/:id" element={<Pages.NewsDetails />} />
      <Route path="/manage-news/add-news" element={<Pages.AddNews />} />
      <Route path="/manage-news/edit/:id" element={<Pages.AddNews />} />
    </Routes>
  );
};
export default Routing;
